import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-morph',
  templateUrl: './morph.component.html',
  styleUrls: ['./morph.component.scss']
})
export class MorphComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
